/**
 * DescriptionList
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
/** Main description for this component. */
var DescriptionList = function (_a) {
    var lineBreak = _a.lineBreak, children = _a.children;
    var renderChildren = function (children) {
        return React.Children.map(children, function (child, index) {
            var props = child && child.props ? __assign({}, child.props) : {};
            props.lineBreak = lineBreak || false;
            return (React.createElement(React.Fragment, { key: index }, React.cloneElement(child, props || {})));
        });
    };
    return React.createElement("dl", null, renderChildren(children));
};
export default DescriptionList;
